<div class="main">
    <div class="reports-container container">
        <div class="row mt-4">
            <div class="col font-medium d-flex align-items-center justify-content-between">
                <span class="d-flex min-h-70">
                    <table *ngIf="projects && projects.length">
                        <tr>
                            <td><b>Project</b></td>
                            <td *ngIf="projectId && projectId!=emptyGuid && projects.length > 0"><b>Department</b></td>
                            <td *ngIf="selectedDepartment && selectedDepartment!=emptyGuid">
                                Room</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>
                                <select #projectselect class="clean-select" [(ngModel)]="projectId"
                                    (change)="getAllDepartments(projectId)">
                                    <option [value]="emptyGuid">All</option>
                                    <option *ngFor='let project of projects' [value]="project.id">
                                        {{project.projectname}}</option>
                                </select>
                            </td>
                            <td *ngIf="projectId && projectId!=emptyGuid && projects.length > 0">
                                <select #departmentselect class="clean-select" [(ngModel)]="selectedDepartment"
                                    (change)="getAllRooms(departmentselect.value)">
                                    <option [value]="emptyGuid">All</option>
                                    <option *ngFor='let department of departments' [value]="department.id">
                                        {{department.departmentname}}</option>
                                </select>
                            </td>
                            <td *ngIf="selectedDepartment && selectedDepartment!=emptyGuid">
                                <select #roomselect class="clean-select" [(ngModel)]="selectedRoom"
                                    (change)="getRequests(roomselect.value)">
                                    <option [value]="emptyGuid">All</option>
                                    <option *ngFor='let room of rooms' [value]="room.id">{{room.name}}
                                        ({{room.roomname}})
                                    </option>
                                </select>
                            </td>
                            <td>
                                <span class="d-flex">
                                    <span>
                                        <img (click)="getRequests(selectedRoom)" ngbTooltip="Refresh" width="44"
                                            height="44" src="assets/images/refresh-icon.png">
                                    </span>
                                    <span>
                                        <ng-container *ngTemplateOutlet="exportToPdf"></ng-container>
                                    </span>
                                </span>
                            </td>
                        </tr>
                    </table>
                </span>
            </div>
        </div>

        <div class="row mt-4">
            <div class="col">
                <div style="height: 600px">
                    <div *ngIf="url;" class="pdf-container">
                        <pdf-viewer [src]="url" [rotation]="0" [original-size]="false" [show-all]="true"
                            [fit-to-page]="false" [zoom]="1" [zoom-scale]="'page-width'" [stick-to-page]="false"
                            [render-text]="true" [external-link-target]="'blank'" [autoresize]="true"
                            [show-borders]="true" style="width: 100%; height: 600px;"></pdf-viewer>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<ng-template #exportToPdf>
    <img (click)="downloadNoteReport()" width="44" height="44" src="assets/images/pdf-icon.png">
    <button [ngClass]="{'disabled-control':!saveToFolder}" class="ml-2 d-print-none button button-action-icon border-0" (click)="openFolderExplorer()">Save to folder</button>
</ng-template>